import { render, staticRenderFns } from "./KeyResultTasks.vue?vue&type=template&id=1f383203&"
import script from "./KeyResultTasks.vue?vue&type=script&lang=js&"
export * from "./KeyResultTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports